<template>
    <div class="error-title">
        <span class="error-title--prefix" v-text="content.title"></span>
        <h1 class="error-title--title" v-text="content.subtitle"></h1>
        <p class="error-title--lead" v-text="content.description"></p>
    </div>
</template>

<script>
    import cmsPlugin from 'vue/mixins/cms/cms-plugin';


    export default {
        mixins: [cmsPlugin],
    };
</script>



// WEBPACK FOOTER //
// index.vue?b230da96